module.exports = __webpack_public_path__ + "img/hs2.93138916.png";